var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { KeyCode, useStateValue } from "../helpers";
import { useEffect, useRef, useState } from 'react';
import { MFA_REQUEST_CODE } from "./types";
export function useCapsLockDetector() {
    var capsLockState = useStateValue(false);
    useEffect(function () {
        function capsLockKeyEventHandler(e) {
            var _a;
            var isActive = (_a = e.getModifierState) === null || _a === void 0 ? void 0 : _a.call(e, 'CapsLock');
            if (isActive !== capsLockState.getValue()) {
                capsLockState.setValue(isActive);
            }
        }
        document.addEventListener('keydown', capsLockKeyEventHandler);
        document.addEventListener('keyup', capsLockKeyEventHandler);
        return function () {
            document.removeEventListener('keydown', capsLockKeyEventHandler);
            document.removeEventListener('keyup', capsLockKeyEventHandler);
        };
    }, []);
    return capsLockState.getValue();
}
export function useLoginFormSubmit(_a) {
    var _this = this;
    var handler = _a.handler, busyModel = _a.busyModel, form = _a.form, externalError = _a.error, onRequestMFACode = _a.onRequestMFACode, onSuccess = _a.onSuccess;
    var unmountRef = useRef(false);
    var errorState = useStateValue('');
    var _b = useState(false), errorHighlight = _b[0], setErrorHighlight = _b[1];
    var _c = useState(false), isSubmitted = _c[0], setSubmittedStatus = _c[1];
    var fieldFocusHandler = function () {
        setErrorHighlight(false);
    };
    useEffect(function () {
        return function () {
            unmountRef.current = true;
        };
    }, []);
    useEffect(function () {
        errorState.setValue(externalError || '');
        setErrorHighlight(!!externalError);
    }, [externalError]);
    var submit = function () {
        var isValid = form.validateAndDisplayErrors();
        if (isValid) {
            setSubmittedStatus(true);
            (function () { return __awaiter(_this, void 0, void 0, function () {
                var requestMFA, error, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, 3, 4]);
                            requestMFA = false;
                            busyModel.update(function (value) {
                                value.loading = true;
                            });
                            errorState.setValue('');
                            return [4 /*yield*/, (handler === null || handler === void 0 ? void 0 : handler(form.getValue()))];
                        case 1:
                            error = _a.sent();
                            if (onRequestMFACode && error === MFA_REQUEST_CODE) {
                                error = '';
                                requestMFA = true;
                            }
                            if (!unmountRef.current) {
                                errorState.setValue(error || '');
                                setErrorHighlight(!!error);
                            }
                            if (requestMFA) {
                                onRequestMFACode === null || onRequestMFACode === void 0 ? void 0 : onRequestMFACode();
                            }
                            if (!error && !requestMFA) {
                                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                            }
                            return [3 /*break*/, 4];
                        case 2:
                            err_1 = _a.sent();
                            errorState.setValue(err_1.message);
                            setErrorHighlight(true);
                            return [3 /*break*/, 4];
                        case 3:
                            busyModel.update(function (value) {
                                value.loading = false;
                            });
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            }); })();
        }
    };
    var keyDownHandler = function (e) {
        if (e.keyCode === KeyCode.Enter) {
            submit();
        }
    };
    return {
        hasError: !!errorState.getValue(),
        errorHighlight: errorHighlight,
        fieldFocusHandler: fieldFocusHandler,
        keyDownHandler: keyDownHandler,
        error: errorState.getValue(),
        submit: submit,
        isSubmitted: isSubmitted
    };
}
export function useAutoFocus() {
    var inputRef = useRef(null);
    useEffect(function () {
        setTimeout(function () {
            var _a;
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }, 50);
    }, []);
    return inputRef;
}
//# sourceMappingURL=hooks.js.map